@if (this.conversationParticipants()) {
  <cam-users-list [users]="this.users$()"></cam-users-list>
}
